export default __webpack_public_path__ + "static/media/search-on.1652eccc.svg";